import { useCallback, useEffect, useRef } from 'react';

/**
 * Returns a function indicating whether the component is mounted.
 */
export const useIsMounted = () => {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
};
